
export default {
    setIdioma(state, data) {
        state.idioma = data
    },
    setIdiomas(state, data) {
        state.idiomas = data
    },
}